exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-info[data-v-74ebdea1]{position:fixed;bottom:.4rem;left:0;right:0;width:95%;margin:0 auto;text-align:center;color:#19191a;line-height:.34rem;font-size:.24rem}.default-info div span[data-v-74ebdea1]{color:#2a2aff}.tips[data-v-74ebdea1]{text-align:center;font-size:.24rem;font-weight:400;color:#19191a;line-height:.34rem}.tips span[data-v-74ebdea1]{color:#2a2aff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74ebdea1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/recruit-answer/index.vue
// module id = RwEc
// module chunks = 1